import { getCloudFunctions } from '../../system/firebase';
import { getFullNameText } from '../textHelper';

export const retrieveStripeCustomer = async ({ stripeCusId }) => {
    const functions = getCloudFunctions();
    const retrieveCustomer = functions.httpsCallable('retrieveStripeCustomer');

    const retrieveCustomerResp = await retrieveCustomer({ customerId: stripeCusId });

    return retrieveCustomerResp;
};

export const createStripeCustomer = async ({ userId, employerId, firstName, middleName, lastName, email, stripeTestClockId }) => {
    const functions = getCloudFunctions();
    const createCustomer = functions.httpsCallable('createStripeCustomer');

    const name = getFullNameText(firstName, middleName, lastName);

    const success = await createCustomer({ userId, employerId, name, email, testClockId: stripeTestClockId });

    return success;
};

export const retrieveStripSubscription = async ({ subscriptionId }) => {
    const functions = getCloudFunctions();
    const retrieveSubscription = functions.httpsCallable('retrieveStripeSubscription');

    const retrieveCustomerResp = await retrieveSubscription({ subscriptionId });

    return retrieveCustomerResp;
};

export const createStripeSubscription = async ({ stripeCusId, tier, monthly, isAdditionalSeat, quantity = 1, stripeDefaultPmId, employerId, trialAvailable } = {}) => {
    const functions = getCloudFunctions();
    const createSubscription = functions.httpsCallable('createStripeSubscription');

    const createSubscriptionResp = await createSubscription({
        customerId: stripeCusId,
        tier,
        monthly,
        isAdditionalSeat,
        quantity,
        paymentMethodId: stripeDefaultPmId,
        employerId,
        trialAvailable,
    });

    return createSubscriptionResp;
};

export const upgradeStripeSubscription = async ({
    stripeSubId,
    stripeSubscriptionItemId,
    existingTier,
    existingMonthly,
    tier,
    monthly,
    subscriptionProrationDate,
    stripeDefaultPmId,
} = {}) => {
    const functions = getCloudFunctions();
    const upgradeStripeSubscription = functions.httpsCallable('upgradeStripeSubscription');

    const upgradeSubscriptionResp = await upgradeStripeSubscription({
        tier,
        monthly,
        existingTier,
        existingMonthly,
        // isAdditionalSeat: false,
        // quantity,
        // existingQuantity,
        subscriptionId: stripeSubId,
        subscriptionItemId: stripeSubscriptionItemId,
        // additionalSeatSubscriptionId,
        // additionalSeatSubscriptionItemId,
        prorationDate: subscriptionProrationDate,
        paymentMethodId: stripeDefaultPmId,
    });

    return upgradeSubscriptionResp?.data;
};

export const createStripeAdditionalSeatSubscription = async ({ stripeCusId, isAdditionalSeat, quantity = 1, stripeDefaultPmId, employerId, trialAvailable } = {}) => {
    const functions = getCloudFunctions();
    const createSubscription = functions.httpsCallable('createStripeSubscription');

    const createSubscriptionResp = await createSubscription({
        customerId: stripeCusId,
        isAdditionalSeat,
        quantity,
        paymentMethodId: stripeDefaultPmId,
        employerId,
        trialAvailable,
    });

    return createSubscriptionResp;
};

export const upgradeStripeAdditionalSeatSubscription = async ({
    stripeAdditionalSeatSubId,
    stripeAdditionalSeatSubscriptionItemId,
    existingQuantity = 0,
    quantity = 1,
    subscriptionProrationDate,
    stripeDefaultPmId,
} = {}) => {
    const functions = getCloudFunctions();
    const upgradeStripeSubscription = functions.httpsCallable('upgradeStripeSubscription');

    const upgradeSubscriptionResp = await upgradeStripeSubscription({
        additionalSeatSubscriptionId: stripeAdditionalSeatSubId,
        additionalSeatSubscriptionItemId: stripeAdditionalSeatSubscriptionItemId,
        isAdditionalSeat: true,
        existingQuantity,
        quantity,
        prorationDate: subscriptionProrationDate,
        paymentMethodId: stripeDefaultPmId,
    });

    return upgradeSubscriptionResp;
};

export const setDefaultCardForStripeCustomer = async ({ stripeCusId, stripePmId } = {}) => {
    const functions = getCloudFunctions();
    const setDefaultCardForCustomer = functions.httpsCallable('setDefaultCardForStripeCustomer');

    const success = await setDefaultCardForCustomer({ customerId: stripeCusId, paymentMethodId: stripePmId });

    return success;
};

export const retrieveStripeUpcomingInvoice = async ({
    stripeCusId,
    tier,
    monthly,
    isAdditionalSeat,
    quantity = 1,
    existingTier,
    existingMonthly,
    existingQuantity,
    stripeSubId,
    stripeSubscriptionItemId,
    stripeAdditionalSeatSubId,
    stripeAdditionalSeatSubscriptionItemId,
    trialAvailable,
} = {}) => {
    const functions = getCloudFunctions();
    const retrieveStripeUpcomingInvoice = functions.httpsCallable('retrieveStripeUpcomingInvoice');

    const retrieveStripeUpcomingInvoiceResp = await retrieveStripeUpcomingInvoice({
        customerId: stripeCusId,
        tier,
        existingTier,
        monthly,
        existingMonthly,
        isAdditionalSeat,
        quantity,
        existingQuantity,
        subscriptionId: stripeSubId,
        subscriptionItemId: stripeSubscriptionItemId,
        additionalSeatSubscriptionId: stripeAdditionalSeatSubId,
        additionalSeatSubscriptionItemId: stripeAdditionalSeatSubscriptionItemId,
        trialAvailable,
    });

    return { newInvoice: retrieveStripeUpcomingInvoiceResp?.data };
};

export const scheduleStripeSubscriptionDowngrade = async ({
    stripeSubId,
    stripeAdditionalSeatSubId,
    tier,
    monthly,
    quantity = 1,
    isAdditionalSeat,
    existingTier,
    existingMonthly,
    existingQuantity = 1,
} = {}) => {
    const functions = getCloudFunctions();
    const scheduleStripeSubscriptionDowngrade = functions.httpsCallable('scheduleStripeSubscriptionDowngrade');

    const scheduleDowngradeResponse = await scheduleStripeSubscriptionDowngrade({
        subscriptionId: isAdditionalSeat ? stripeAdditionalSeatSubId : stripeSubId,
        tier,
        monthly,
        quantity,
        isAdditionalSeat,
        existingTier,
        existingMonthly,
        existingQuantity,
    });

    return scheduleDowngradeResponse?.data;
};

export const requestCancelNewAdditionalSeatSubscriptionNow = async ({ stripeSubId, stripeAdditionalSeatSubId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const requestCancelNewStripeSubscriptionNow = functions.httpsCallable('requestCancelNewStripeSubscriptionNow');

        const resp = await requestCancelNewStripeSubscriptionNow({
            subscriptionId: stripeSubId,
            additionalSeatSubId: stripeAdditionalSeatSubId,
            isAdditionalSeatOnly: true,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const requestCancelNewSubscriptionNow = async ({ stripeSubId, stripeAdditionalSeatSubId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const requestCancelNewStripeSubscriptionNow = functions.httpsCallable('requestCancelNewStripeSubscriptionNow');

        const resp = await requestCancelNewStripeSubscriptionNow({
            subscriptionId: stripeSubId,
            additionalSeatSubId: stripeAdditionalSeatSubId,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const requestCancelAdditionalSeatSubscriptionAtPeriodEnd = async ({ stripeAdditionalSeatSubId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const requestCancelStripeSubscriptionAtPeriodEnd = functions.httpsCallable('requestCancelStripeSubscriptionAtPeriodEnd');

        const resp = await requestCancelStripeSubscriptionAtPeriodEnd({
            additionalSeatSubId: stripeAdditionalSeatSubId,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const requestCancelSubscriptionAtPeriodEnd = async ({ stripeSubId, stripeAdditionalSeatSubId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const requestCancelStripeSubscriptionAtPeriodEnd = functions.httpsCallable('requestCancelStripeSubscriptionAtPeriodEnd');

        const resp = await requestCancelStripeSubscriptionAtPeriodEnd({
            subscriptionId: stripeSubId,
            additionalSeatSubId: stripeAdditionalSeatSubId,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const requestCancelSubscriptionAtTierPeriodEnd = async ({ stripeSubId, stripeAdditionalSeatSubId, isUndo } = {}) => {
    try {
        const functions = getCloudFunctions();
        const requestCancelStripeAddtnlSeatSubAtTierPeriodEnd = functions.httpsCallable('requestCancelStripeAddtnlSeatSubAtTierPeriodEnd');

        const resp = await requestCancelStripeAddtnlSeatSubAtTierPeriodEnd({
            subscriptionId: stripeSubId,
            additionalSeatSubId: stripeAdditionalSeatSubId,
            isUndo,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const fetchStripeInvoiceListByCustomer = async ({ stripeCusId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const retrieveStripeInvoiceList = functions.httpsCallable('retrieveStripeInvoiceList');

        const resp = await retrieveStripeInvoiceList({
            customerId: stripeCusId,
        });

        return { data: resp?.data };
    } catch (error) {
        return { error: error.message };
    }
};

export const createCardSetupIntent = async ({ stripeCusId } = {}) => {
    try {
        const functions = getCloudFunctions();
        const createStripeSetupIntent = functions.httpsCallable('createStripeSetupIntent');

        const resp = await createStripeSetupIntent({
            customerId: stripeCusId,
            paymentMethodTypeList: ['card'],
        });

        return { data: resp?.data };
    } catch (error) {
        return { error: error.message };
    }
};

export const createAdCheckoutSession = async ({ email, quantity } = {}) => {
    try {
        const functions = getCloudFunctions();
        const createStripeCheckoutSession = functions.httpsCallable('createStripeCheckoutSession');

        const resp = await createStripeCheckoutSession({
            type: 'advertise',
            email,
            quantity,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};

export const createAdPaymentIntent = async ({ adIdList, receiptEmail, description, metadata } = {}) => {
    try {
        const functions = getCloudFunctions();
        const createStripeAdPaymentIntent = functions.httpsCallable('createStripeAdPaymentIntent');

        const resp = await createStripeAdPaymentIntent({
            adIdList,
            receiptEmail,
            description,
            metadata,
        });

        return { data: resp?.data };
        ////
    } catch (error) {
        return { error: error.message };
    }
};
